import { theme } from '../theme';
import { DayCard } from '../components/DayCard';
import { Heatmap } from '../components/Heatmap';
import { WeekCard } from '../components/WeekCard';
import { BossCard } from '../components/BossCard';
import { SeasonFinale } from '../components/SeasonFinale';
import { QuickAdd } from '../components/QuickAdd';
import { OnboardingCard } from '../components/OnboardingCard';

/**
 * «Обложка»: день в фокусе + мост в неделю (внутри DayCard), ниже — три
 * плотности (Антверпен 2.0 §1): интерактивный объект (квест+сундук) →
 * тёмная афиша (босс, финал) → тихая фактура (цепочка). Номера секций —
 * только у каталожных разворотов (Тренды/Накопления), не здесь.
 */
export function Dashboard() {
  return (
    <div style={{ padding: '8px 22px 40px' }}>
      <DayCard />

      <div style={{ marginTop: 4 }}>
        <QuickAdd />
      </div>

      <OnboardingCard />

      <WeekCard />

      <BossCard />

      <div style={{ marginTop: 14 }}>
        <SeasonFinale />
      </div>

      <div style={{ marginTop: 18, borderTop: `1px solid ${theme.colors.line}`, paddingTop: 16 }}>
        <Heatmap />
      </div>
    </div>
  );
}
